






























































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapActions } from "vuex";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import HomeVideo from "@/components/HomeVideo2.vue"; // @ is an alias to /src
import { cookie } from "../http/utils";
import config from "../http/config";

@Component({
  components: {
    HomeVideo,
  },
})
export default class Home extends Vue {
  // localeCode = 'zh-CN'
  isLoadMore = true;
  currentIndex = 0;
  navLists = [
    {
      title: "home.text28",
      content: "home.text29",
    },
    {
      title: "home.text30",
      content: "home.text31",
    },
    {
      title: "home.text32",
      content: "home.text33",
    },
    {
      title: "home.text34",
      content: "home.text35",
    },
    {
      title: "home.text36",
      content: "home.text37",
    },
  ];
  percentList = [
    {
      number: "50",
      title: "home.text44",
      content: "home.text45",
    },
    {
      number: "87",
      title: "home.text46",
      content: "home.text47",
    },
    {
      number: "95",
      title: "home.text48",
      content: "home.text49",
    },
  ];
  corporations = [
    {
      code: "icon-Native",
      title: "home.text55",
      content: "home.text56",
    },
    {
      code: "icon-protection",
      title: "home.text57",
      content: "home.text58",
    },
    {
      code: "icon-tencent",
      title: "home.text61",
      content: "home.text62",
    },
  ];
  courseNew: any = [];
  hotLangCourse = [
    "ENG",
    "FRE",
    "JPN",
    "KOR",
    "GER",
    "RUS",
    "ITA",
    "CHI",
    "CAN",
    "SPA",
  ];
  allCourse: any = [];
  allLangCourse: any = [];
  langCourse: any = [];
  moreLangCourse: any = [];
  mounted() {
    this.swiperInit();
    this.initCourse();
  }
  get localeCode() {
    console.log("==>", this.$i18n.locale);
    let cale = this.$i18n.locale;
    return cale;
  }
  // 处理课程的方法
  initCourse() {
    let _this = this;
    _this.$store.dispatch("getCourseLangs").then((res) => {
      console.log("新的课程列表接口返回", res);
      let array: any = res.courseInfo.listCourses; // 所有的课程
      let hotArray: any = res.courseInfo.hotCourses; // 热门课程
      let miniArray: any = res.courseInfo.kidCourses; // mini课程
      let newMiniArr: any = [];
      miniArray.forEach((item: any, index: any) => {
        let obj = {
          code: item.code,
          flag: item.flag,
          name: item.name + " Mini",
        };
        newMiniArr.push(obj);
      });
      /* eslint-disable */
      let hash: any = {};
      this.allCourse = [...newMiniArr, ...hotArray, ...array].reduce(
        (item, next) => {
          hash[next.code] ? "" : (hash[next.code] = true && item.push(next));
          return item;
        },
        []
      );
      /* eslint-enabled */
      console.log(this.allCourse);
      this.langCourse = this.allCourse.slice(0, 20);
    });
  }
  experience() {
    this.isLoadMore = true;
    this.loadMore();
  }
  // 加载更多
  loadMore() {
    this.isLoadMore = !this.isLoadMore;
    // 这是新接口的数据
    if (!this.isLoadMore) {
      this.moreLangCourse = this.allCourse.slice(20);
    } else {
      this.langCourse = this.allCourse.slice(0, 20);
    }
  }
  // 匿名用户登录 判断是登录or匿名状态
  anonymousGoLearn(obj: any) {
    let code = obj.code;
    console.log("当前code=>", code);
    let params = {};
    let userId = cookie.getCookie("user_id");
    console.log("params前code=>", params);
    console.log("userId=>", userId);
    window.zhuge.track("点击选择课程", {
      code: obj.code,
      name: obj.name,
    });
    if (userId) {
      params = {
        code: code,
      };
      this.$store.dispatch("getPurchaseCourse", params).then((res) => {
        cookie.autoCookie("purchaseCourseCode", code);
        window._czc.push([
          "_trackEvent",
          "官网首页",
          "正式用户按钮链接点击",
          "官方课程-" + code,
          "",
          "",
        ]);
        if (
          code === "KEN-Basic" ||
          code === "KSP-Basic" ||
          code === "KFR-Basic"
        ) {
          window.location.href =
            config.rootDomain + "/app/kid-course-list/" + code;
        } else {
          window.location.href = config.rootDomain + "/app/course-list/" + code;
        }
      });
    } else {
      params = {
        preferLangs: code,
        skillLangs: code,
        course_code: code,
      };
      this.$store.dispatch("getGenerateSign", params).then((data) => {
        console.log("data=>", data);
        if (data.success) {
          window.zhuge.identify(data.result.user_id, data.result);
          cookie.autoCookie("user_id", data.result.user_id);
          cookie.autoCookie("verify", data.result.verify);
          cookie.autoCookie("is_anonymous", data.result.is_anonymous);
          cookie.autoCookie("purchaseCourseCode", code);
          window._czc.push([
            "_trackEvent",
            "官网首页",
            "匿名用户按钮链接点击",
            "官方课程-" + code,
            "",
            "",
          ]);
          if (
            code === "KEN-Basic" ||
            code === "KSP-Basic" ||
            code === "KFR-Basic"
          ) {
            window.location.href =
              config.rootDomain + "/app/kid-course-list/" + code;
          } else {
            window.location.href =
              config.rootDomain + "/app/course-list/" + code;
          }
        }
      });
    }
  }
  // 轮播
  swiperInit() {
    this.$nextTick(() => {
      // var peopleSwiper = new Swiper('.swiper-container1', {
      //   autoplay: 5000,
      //   speed: 500,
      //   loop: true,
      //   pagination: '.swiper-pagination1',
      //   paginationClickable: true,
      //   prevButton: '.swiper-button-prev',
      //   nextButton: '.swiper-button-next'
      // })
      var talkAboutSwiper = new Swiper(".swiper-container2", {
        autoplay: 5000,
        speed: 500,
        loop: true,
        pagination: ".swiper-pagination2",
        paginationClickable: true,
      });
      var talkAboutSwiper1 = new Swiper(".swiper-container3", {
        speed: 500,
        loop: true,
        pagination: ".swiper-pagination3",
        paginationClickable: true,
      });
    });
  }
  // 导航切换
  navChanged(index: number) {
    this.currentIndex = index;
  }
  // 进入世界语言地图
  enterWorldMap() {
    window.zhuge.track("点击进入世界语言地图");
    window._czc.push([
      "_trackEvent",
      "官网首页",
      "按钮链接点击",
      "进入世界语言地图",
      "",
    ]);
    window.location.href = config.rootDomain + "/app/index";
  }
}
